import { render, staticRenderFns } from "./yieldXin.vue?vue&type=template&id=05310a8a&scoped=true&"
import script from "./yieldXin.vue?vue&type=script&lang=js&"
export * from "./yieldXin.vue?vue&type=script&lang=js&"
import style0 from "./yieldXin.vue?vue&type=style&index=0&id=05310a8a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05310a8a",
  null
  
)

export default component.exports